import { Redirect } from 'expo-router';

// Πιάνει οποιοδήποτε deep link δεν ταιριάζει με καμία οθόνη (π.χ. Android
// ανοίγει την εφαρμογή μέσω tap σε push notification με άδειο/μη έγκυρο URL
// — heirapsia:///) — χωρίς αυτό, ο χρήστης έμενε κολλημένος σε ένα ορφανό 404
// έξω από το (app) group, όπου ζει το usePushNotifications hook που θα έκανε
// το σωστό redirect στη σχετική συμφωνία/chat. Στέλνει στη ρίζα της εφαρμογής
// — η δική της route guard (useProtectedRoute) αναλαμβάνει από εκεί.
export default function NotFoundScreen() {
  return <Redirect href="/(app)" />;
}
